export * from './src/badges-v3-badge-badges.context.js';
